const displayNamesCache = new Map<string, Intl.DisplayNames>();

const getDisplayNames = (locale: string): Intl.DisplayNames => {
  let displayNames = displayNamesCache.get(locale);
  if (!displayNames) {
    displayNames = new Intl.DisplayNames([locale], { type: "region" });
    displayNamesCache.set(locale, displayNames);
  }
  return displayNames;
};

export const countryDisplayName = (
  code: string | undefined | null,
  locale = "en"
): string => {
  if (!code) return "";
  const upperCode = code.toUpperCase();
  try {
    return getDisplayNames(locale).of(upperCode) ?? upperCode;
  } catch {
    return upperCode;
  }
};
